import { Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { CurrentUserService } from '../../core/services/Current-user/currentuser.service';

@Directive({
  selector: '[appCheckAccess]',
})
export class CheckAccessDirective implements OnDestroy {
  private access: string;
  private readonly menuReadySubscription: Subscription;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private currentuserservice: CurrentUserService,
  ) {
    this.menuReadySubscription = this.currentuserservice.menuReady$.subscribe(() => {
      this.evaluate();
    });
  }

  @Input() set appCheckAccess(access: string) {
    this.access = access;
    this.evaluate();
  }

  private evaluate(): void {
    if (this.access == undefined) return;
    if (this.currentuserservice.user.adminMenu?.[this.access]) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  ngOnDestroy(): void {
    this.menuReadySubscription.unsubscribe();
  }
}
